import { Button } from '../../ui';

/**
 * Continue button with an optional fill animation that telegraphs the
 * 2s auto-advance window on Stage 2.5. Drives the fill via CSS so it
 * stays smooth without requestAnimationFrame.
 *
 * Props:
 *   autoAdvanceAt  — timestamp the auto-advance timer was scheduled.
 *                    null / undefined → render a plain Continue (no fill).
 *   duration       — duration in ms of the fill (defaults to 2000).
 *   onClick        — clicked handler (advance immediately).
 */
export default function TimedContinueButton({ autoAdvanceAt, duration = 2000, onClick, ...rest }) {
  const fillEnabled = autoAdvanceAt != null;

  return (
    <Button
      onClick={onClick}
      data-testid="onboarding-continue"
      className="relative overflow-hidden"
      {...rest}
    >
      {/* Overlay sits behind the label, animating from 0% to 100% width
          over `duration` ms. `key={autoAdvanceAt}` so a fresh timer
          remounts the overlay and restarts the animation. */}
      {fillEnabled && (
        <span
          key={autoAdvanceAt}
          aria-hidden="true"
          className="absolute inset-0 bg-white/15 dark:bg-black/20 origin-left animate-onboarding-continue-fill pointer-events-none"
          style={{ animationDuration: `${duration}ms` }}
        />
      )}
      <span className="relative z-10">Continue</span>
    </Button>
  );
}
